import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { getPlaylist } from 'Redux/selectors/playLists'
import { getSpotifyToken } from 'Redux/selectors/spotifyToken'
import {
  changePlaylistGenres,
  changePlaylistInformation,
  updatePlaylists,
  checkPlaylist,
  setPlaylistGenresLimit,
  updateStatePlaylists,
  getPlaylists,
  setDeactivationAlertRead,
} from 'Redux/actions/playListsActions'
import { getCuratorRank, setPlaylistRequirement } from 'Redux/actions/auth'
import { getAutoselectedSpotifyPlaylistGenres } from 'Redux/actions/genresActions'
import { getUser } from 'Redux/selectors/auth'
import { getGenres } from 'Redux/selectors/genres'
import { getLanguages } from 'Redux/selectors/languages'
import Component from './Playlists'

const selector = createStructuredSelector({
  playlists: getPlaylist,
  spotifyAccessToken: getSpotifyToken,
  genres: getGenres,
  user: getUser,
  languages: getLanguages,
})

const actions = {
  updatePlaylists,
  getCuratorRank,
  changePlaylistGenres,
  changePlaylistInformation,
  checkPlaylist,
  setPlaylistRequirement,
  getAutoselectedSpotifyPlaylistGenres,
  setPlaylistGenresLimit,
  updateStatePlaylists,
  getPlaylists,
  setDeactivationAlertRead,
}

export default connect(selector, actions)(Component)
